export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '79c4a793-3c3f-4a98-a539-7d17a3c6ae64';
export const MODAL_CLOSE_SEC = 2.5;
